module.exports = __webpack_public_path__ + "static/paw-bubbles-ac0c2e379c037cda748c0938efe1ac7b.svg";